<template>
    <div>
        <b-modal
            id="modal-report-edit"
            size="md"
            centered
            :title="modalTitle"
            ok-title="Rapor Oluştur"
            ok-variant="success"
            cancel-title="İptal"
            cancel-variant="outline-secondary"
            @ok.prevent="postParameterListsinaReportCreate">

            <p v-if="$store.state.report.report.length === 0" style="text-align:center">Rapor için "Rapor Oluştur" butonuna tıklayınız.</p>
            <div class="row" v-for="(itemReport,index) in $store.state.report.report" :key="index">
                <div class="col-sm-12" v-if="itemReport.type === 5">
                    <div class="form-group">
                    <label>{{itemReport.description}}</label>
                        <date-picker v-model="itemReport.value" input-class="form-control" format="DD.MM.YYYY" valueType="format"></date-picker>
                    </div>
                </div>
                <div class="col-sm-12" v-if="itemReport.type === 100">
                  <div class="form-group">
                    <label>{{itemReport.description}}</label>
                    <select v-select class="form-control" v-model="itemReport.value">
                      <option :value="0">Seçiniz</option>
                      <option :value="item.id" v-for="(item,index) in mblist" :key="index">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
        </b-modal>
        <div class="standart-page">
            <div class="row mb-3">
            <div class="col d-flex align-items-center justify-content-center">
                <h3 class="title mb-0">Raporlar</h3>
            </div>
            </div>
            <div class="accordion" role="tablist">
                <b-card no-body v-for="(item,index) in $store.state.report.reportGroup" :key="index">
                    <b-card-header header-tag="header" role="tab" class="mr-0" @click="toggle(item)">
                        <b-button class="w-100 text-left d-flex justify-content-between btn btn-link font-weight-bold" variant="null">
                            {{item.description}}
                            <span class="when-opened"><font-awesome-icon icon="chevron-down"/></span>
                            <span class="when-closed"><font-awesome-icon icon="chevron-right"/></span>
                        </b-button>
                    </b-card-header>
                    <b-collapse :id="'accordion-' + item.recordId" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <div class="table-responsive">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>Rapor</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="cursor-pointer" v-for="(itemListina,index) in $store.state.report.listina" :key="index" @click="getParameterListsinaReportList(itemListina)">
                                            <td>{{ itemListina.description }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapActions, mapGetters } from "vuex";
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import 'vue2-datepicker/locale/tr';

    export default {
        components: {
            DatePicker
        },
        data() {
            return {
                modalTitle:"Rapor Oluştur",
                mblist:[]
            };
        },
        methods: {
            ...mapActions("general", ["showModal", "errorHandling"]),
            ...mapActions('uye', ['getMBList']),
            ...mapActions("report", ["getReportGroup", "getReportListinaGroup", "getParameterListsinaReport", "postParameterListsinaReport"]),
            getReportGroupList(){
                this.$store.state.general.showOverlay = true;
                this.getReportGroup().then(res => {
                    if(res.errorCode !== 0){
                        this.errorHandling(res);
                    }
                    this.$store.state.general.showOverlay = false;
                });
            },
            getReportListinaGroupList(item){
                this.$store.state.general.showOverlay = true;
                this.getReportListinaGroup(item.recordId).then(res => {
                    if(res.errorCode !== 0){
                        this.errorHandling(res);
                    }
                    this.$store.state.general.showOverlay = false;
                });
            },
            getParameterListsinaReportList(item){
                this.$store.state.general.showOverlay = true;
                this.getParameterListsinaReport(item.recordId).then(res => {
                    if(res.errorCode !== 0){
                        this.errorHandling(res);
                    }else{
                        this.$bvModal.show('modal-report-edit');
                        this.modalTitle = item.description;
                        this.$store.state.report.recordId = item.recordId;
                    }
                    this.$store.state.general.showOverlay = false;
                });
            },
            postParameterListsinaReportCreate(){
                let request = {
                    reportId:this.$store.state.report.recordId,
                    parameters:[]
                }
                this.$store.state.report.report.forEach(element => {
                    request.parameters.push({key:element.name, value:element.value});
                });
                this.$store.state.general.showOverlay = true;
                this.postParameterListsinaReport(request).then(res => {
                    if(res.errorCode !== 0){
                        this.errorHandling(res);
                    }else{
                        this.$bvModal.hide('modal-report-edit');
                        this.showModal({title: 'İşlem Başarılı', message: this.getMessage(53), type: 'success'});
                    }
                    this.$store.state.general.showOverlay = false;
                });
            },
            getMBListOptions(){
                this.getMBList().then(res => {
                    if(res.errorCode == 0){
                        this.mblist = res.data;
                    }else{
                        this.errorHandling(res);
                    }
                    this.$store.state.general.showOverlay = false;
                });
            },
            toggle(item) {
                this.$store.state.report.listina = [];
                this.$root.$emit('bv::toggle::collapse', 'accordion-' + item.recordId);
                this.getReportListinaGroupList(item);
            }
        },
        created() {
            this.getMBListOptions();
            this.getReportGroupList();
        },
        computed: {
            ...mapGetters("general", ["getMessage"]),
        },
        watch: {},
    };
</script>